export default __webpack_public_path__ + "static/media/Supercharge-Your-Career-2.982cfce7.png";